import { render, staticRenderFns } from "./sysUploadFileType.vue?vue&type=template&id=c35cdd1a&"
import script from "./sysUploadFileType.vue?vue&type=script&lang=js&"
export * from "./sysUploadFileType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports